import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCategories } from "./request-orders.service";
import RequestIcon from "../../shared/assets/images/svg/request_orders.svg";
import "./requestOrders.scss";

const RequestOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then((data) => setCategories(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="settingHome">
      <div className="container">
        <h1 className="page-title">{t("request-orders.mainTitle")}</h1>
        <hr className="hr" />

        {loading ? (
          <div className="loading-spinner">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : categories.length === 0 ? (
          <p className="no-data">{t("request-orders.noCategories")}</p>
        ) : (
          <div className="row">
            {categories.map((cat) => (
              <div key={cat.id} className="col-lg-3 col-md-6">
                <div
                  className="settingCard request-category-card"
                  onClick={() => navigate(`/request-orders/${cat.id}`, { state: { categoryName: cat.name } })}
                >
                  <img className="icon" src={RequestIcon} alt="icon" />
                  <h1 className="title">{cat.name}</h1>
                  <p className="info">{t("request-orders.categoriesDesc")}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestOrders;
